import { orchestrator } from 'satcheljs';
import { tryUndoProcessSharePointLink } from '../actions/publicActions';
import { SP_LINK_CLICK_EVENT_LISTENER, SP_LINK_MOUSEUP_EVENT_LISTENER } from '../utils/constants';

orchestrator(tryUndoProcessSharePointLink, actionMessage => {
    const { elements } = actionMessage;
    if (elements) {
        elements.forEach(element => {
            const eventListener = element[SP_LINK_CLICK_EVENT_LISTENER];
            if (eventListener) {
                element.removeEventListener('click', eventListener);
                element[SP_LINK_CLICK_EVENT_LISTENER] = null;
            }
            const mouseUpEventListener = element[SP_LINK_MOUSEUP_EVENT_LISTENER];
            if (mouseUpEventListener) {
                element.removeEventListener('mouseup', mouseUpEventListener);
                element[SP_LINK_MOUSEUP_EVENT_LISTENER] = null;
            }
        });
    }
});
